import UsuarioService from '../_services/UsuarioService'
import { usuarioModel } from './../_model/usuario'
import { erroArrayToString } from '@/utils/trataErroRetornoApi'

const state = {
  loading: false,
  loadingStore: false,
  usuarios: [],
  dropdownUsuario: [],
  usuarioSelecionado: undefined,
  erros: '',

}

const getters = {
  GET_USUARIOS : (state) => state.usuarios,
  GET_DROPDOWN: state => state.dropdownUsuario,
  GET_ERROS: state => state.erros,
}

const mutations = {

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false
  },

  USUARIO_SELECTED : (state, { usuario }) => {
    state.usuarioSelecionado = Object.assign({}, usuario)
  },

  SET_USUARIOS : (state, { usuarios }) => {
    state.usuarios = usuarios
  },

  SET_DROPDOWN : (state, usuarios) => {
    state.dropdownUsuario = usuarios
  },

  SET_ERROS : (state, erros) => {
    state.erros = erros.erros
  },

  ERASE_ERROS : (state) => {
    state.erros = ''
  },

  RESET_SELECTED : state => state.usuarioSelecionado = undefined,

}

const actions = {

  LOAD_DROPDOWN : ({commit}) => {

    return new Promise((resolve, reject) => {
      commit('SET_DROPDOWN', [])
      commit('ERASE_ERROS')
      UsuarioService.getDropDown()
      .then(response => {
        if (response.data.status) {
          var drop = []
          var obj = response.data.usuarios
          drop.push({value:"", text:""})
          Object.keys(obj).forEach(function (item) {
            var array = { value: obj[item].id, text: obj[item].nm_usuario ? obj[item].nm_usuario : obj[item].ds_email}
            drop.push(array)
          })
          commit('SET_DROPDOWN', drop)
          resolve()
  
        } else if (response.data.erro) {
          commit('SET_ERROS', { erros: response.data.erro })
          reject()
        }
      })
      .catch(error => {
        console.log(error)
        commit('SET_ERROS', { erros: 'Erro ao acessar api' })
        reject(error)
      })
    })
  },

  GET_USUARIOS : async ({ commit }) => {
    commit('SET_USUARIOS', { usuarios : []})
    commit('ERASE_ERROS')
    await UsuarioService.getUsuarios()
    .then(response => {
      if (response.data.status) {
        commit('SET_USUARIOS', { usuarios : response.data.usuarios })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })
  },

  GET_USUARIO : async ({commit}, id) => {
    commit('ERASE_ERROS')
    await UsuarioService.getUsuario(id)
    .then(response => {
      if (response.data.status) {
        commit('USUARIO_SELECTED', { usuario : response.data.usuario })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }
    })
    .catch(error => {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    })

  },

  STORE_USUARIO : async ({ commit, dispatch, rootGetters }, usuario) => {
    commit('ERASE_ERROS')
    try {
      commit('SET_LOADING_STORE', true)
      if (!usuario.id || !(usuario.id > 0)) { 
        var response = await UsuarioService.postUsuario(usuario)
      } else {
        var response = await UsuarioService.putUsuario(usuario.id, usuario)
      }

      if (response.data.status) {
        commit('USUARIO_SELECTED', { usuario : response.data.usuario })
        let emailUser = rootGetters['login/getUsuario']
        if (response.data.usuario.ds_email === emailUser.ds_email) {
          let avatar = null
          if (response.data.usuario.foto) avatar = response.data.usuario.foto
          commit('login/atualizaAvatar', avatar, { root: true })
        }
        await dispatch('GET_USUARIOS')

      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros)
        commit('SET_ERROS', { erros: erros })
      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    } finally {
      commit('SET_LOADING_STORE', false)
    }
  },

  DELETE_USUARIO : async ({ commit, dispatch }, usuario) => {
    commit('ERASE_ERROS')
    try {
      var response = await UsuarioService.deleteUsuario(usuario.id)

      if (response.data.status) {
        await dispatch('GET_USUARIOS')

      } else if (response.data.erro) {
        commit('SET_ERROS', { erros: response.data.erro })
      }

    } catch (error) {
      console.log(error)
      commit('SET_ERROS', { erros: 'Erro ao acessar api' })
      reject(error)
    }
  },

  USUARIO_SELECTED : async ({dispatch, commit}, id) => {
    if (id > 0) { 
      await dispatch('GET_USUARIO', id)
    } else {
      var obj = new usuarioModel.usuario()
      await commit('USUARIO_SELECTED', { usuario: obj })
    }    
  },

  RESET_SELECTED : ( {commit} ) => { commit('RESET_SELECTED') },

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
} 


// WEBPACK FOOTER //
// ./src/views/Usuario/_store/index.js